<script lang="ts" setup>
import { computed } from 'vue'
import QuoteSummary from '@/models/dto/quoteSummary/QuoteSummary'
import { isExpiredV2 } from '@/utils/quote'
import { expirationDelta } from '@/utils/string'

interface Props {
  row: QuoteSummary
}

const props = defineProps<Props>()

const isExpired = computed(() => {
  const isPastExpiration = props.row.expirationDatetime && isExpiredV2(props.row.expirationDatetime)
  const isPickupInPast = props.row.pickupDatetime && new Date(props.row.pickupDatetime) < new Date()
  return isPickupInPast || isPastExpiration
})

const expirationText = computed(() => {
  if (isExpired.value) {
    return 'Expired'
  }
  if (!props.row.expirationDatetime) {
    return ''
  }
  return expirationDelta(props.row.expirationDatetime)
})

const isExpiringWithin24Hours = computed(() => {
  if (!props.row.expirationDatetime) {
    return false
  }
  const hoursDiff = (new Date(props.row.expirationDatetime).getTime() - Date.now()) / (1000 * 60 * 60)
  return hoursDiff < 24 && hoursDiff > 0
})

</script>

<template>
  <div
    class="d-flex align-center"
    :class="{ 'text-error font-medium': isExpired }"
  >
    <CUIcon
      v-if="isExpiringWithin24Hours"
      color="error"
      view-box="0 0 24 24"
      class="w-18 h-18 margin-r-1"
    >
      access_time
    </CUIcon>
    {{ expirationText }}
  </div>
</template>
